import { getControllerApiVersion } from './utils.js';

const ESP32_S3_INTERNAL_STORAGE_API_MIN = 'BAG';
const ROOTSENSE_FIRMWARE_API_MIN = 'BAICA';

export const extensionFirmwareFields = ['root_sense_link', 'power_extender'].flatMap((device) =>
  ['flags', 'major', 'minor', 'patch'].map((part) => `${device}_fw_${part}`)
).concat('root_sense_link_hw_variant');

export function supportsRootSenseFirmwareVersion(controller) {
  return Number(controller?.type) === 5055 &&
    getControllerApiVersion(controller).localeCompare(ROOTSENSE_FIRMWARE_API_MIN) >= 0;
}

export function getRootSenseLinkFirmwareVersion(controller) {
  const system = controller?.settings?.system;
  if (!supportsRootSenseFirmwareVersion(controller) || !(system?.root_sense_link_fw_flags & 1))
    return null;
  if (!(system.root_sense_link_fw_flags & 2) ||
      !(system.root_sense_link_fw_major || system.root_sense_link_fw_minor || system.root_sense_link_fw_patch))
    return '';
  return `1400${system.root_sense_link_hw_variant || 1}.${system.root_sense_link_fw_major}.${system.root_sense_link_fw_minor}.${system.root_sense_link_fw_patch}`;
}

// ESP-based controllers obtain recovery firmware choices from /api/versions.
// Industrial Pro obtains its choices from settings and keeps its existing flow.
export function canOpenFirmwareRecovery(controller) {
  return (
    [5052, 5053, 5055, 5155].includes(controller?.type) &&
    (controller.access_rights?.system ?? { read: true }).read === true
  );
}

function getLiveFirmwareControllerType(controller) {
  const system = controller?.settings?.system ?? controller?.system;
  const mainControllerFirmware = String(system?.fw_version_number ?? '').trim();
  const wifiFirmware = String(system?.esp32_firmware_name ?? '').trim();

  if (/^505[235](?:\.|pre)/i.test(mainControllerFirmware) || /^505w(?:\.|pre)/i.test(wifiFirmware)) {
    return 5055;
  }
  if (/^5155(?:\.|pre)/i.test(mainControllerFirmware) || /^515w(?:\.|pre)/i.test(wifiFirmware)) {
    return 5155;
  }
  return null;
}

export function getFirmwareUpdateOtaInfoKey(controller) {
  const controllerType = getLiveFirmwareControllerType(controller) ?? Number(controller?.type);
  if ([5052, 5053, 5055].includes(controllerType)) return 'fw_update_ota_info_505x';
  if (controllerType === 5155) return 'fw_update_ota_info';
  return null;
}

export function shouldShowFilesystemStatus(controller) {
  return !(
    Number(controller?.type) === 5155 &&
    getControllerApiVersion(controller).localeCompare(ESP32_S3_INTERNAL_STORAGE_API_MIN) >= 0
  );
}
